import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const pause = (duration) => {
  return new Promise((resolve) => setTimeout(resolve, duration));
};

const teamApi = createApi({
  reducerPath: "team",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BASE_ENDPOINT}api`,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem("access-token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
    },
    fetchFn: async (...args) => {
      await pause(1000);
      return fetch(...args);
    },
  }),
  endpoints(builder) {
    return {
      fetchTeams: builder.query({
        providesTags: (result) => ["teams"],
        query: () => {
          return {
            url: `team`,
            method: "GET",
          };
        },
      }),
      createTeam: builder.mutation({
        invalidatesTags: ["teams"],
        query: (body) => {
          return {
            url: `team`,
            method: body.id === 0 ? "POST" : "PUT",
            body,
          };
        },
      }),
      deleteTeam: builder.mutation({
        invalidatesTags: ["teams"],
        query: (id) => {
          return {
            url: `team?Id=${id}`,
            method: "DELETE",
          };
        },
      }),
      fetchTeamByUserId: builder.query({
        providesTags: (result) => ["user-teams"],
        query: (userId) => {
          return {
            url: `teamuser/user/?userId=${userId}`,
            method: "GET",
          };
        },
      }),
    };
  },
});

export const {
  useFetchTeamsQuery,
  useFetchTeamByUserIdQuery,
  useCreateTeamMutation,
  useDeleteTeamMutation
} = teamApi;
export { teamApi };
